<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <circle cx="8.5" cy="4" r="2" fill="#E5E5E5"/>
  <path d="M4 15V10.5C4 9.1 5.1 8 6.5 8H10.5C11.9 8 13 9.1 13 10.5V15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
</svg>
